import { useState } from "react";
import { Link } from "react-router-dom";
import { TrashIcon, ArrowCounterClockwiseIcon, CaretDownIcon } from "@phosphor-icons/react";
import { useTrash } from "../lib/useTrash";
import { reasonMeta } from "./TrashButton";

export const TrashBin = () => {
  const { items, untrash } = useTrash();
  const [open, setOpen] = useState(false);
  if (!items || items.length === 0) return null;

  return (
    <div className="border border-danger/25 bg-danger/[0.04]" data-testid="trash-bin">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="trash-bin-toggle"
        className="w-full flex items-center gap-2.5 px-4 py-2.5 text-left hover:bg-white/[0.03] transition-colors"
      >
        <TrashIcon size={17} weight="bold" className="text-danger shrink-0" />
        <span className="text-sm font-semibold text-white">Trash bin</span>
        <span className="font-mono text-xs text-muted-foreground">({items.length} hidden)</span>
        <span className="flex-1" />
        <span className="text-xs text-muted-foreground hidden sm:inline">skulled by mistake? restore here</span>
        <CaretDownIcon size={16} weight="bold" className={`text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="border-t border-white/10 max-h-[340px] overflow-y-auto divide-y divide-white/5" data-testid="trash-bin-list">
          {items.map((it) => {
            const rm = reasonMeta(it.reason);
            return (
              <div key={it.mint} data-testid={`trash-bin-item-${it.mint}`} className="flex items-center gap-2.5 px-4 py-2.5">
                <Link to={`/coin/${it.mint}`} className="font-heading font-bold text-sm hover:text-neon transition-colors shrink-0">
                  ${it.symbol || it.mint.slice(0, 4)}
                </Link>
                {rm && (
                  <span className="text-[10px] font-mono px-1.5 py-0.5 bg-danger/15 border border-danger/40 text-danger whitespace-nowrap">
                    {rm.emoji} {rm.label}
                  </span>
                )}
                <span className="font-mono text-[10px] text-muted-foreground truncate hidden sm:inline">{it.mint.slice(0, 6)}…{it.mint.slice(-4)}</span>
                <span className="flex-1" />
                <button
                  onClick={() => untrash(it.mint)}
                  data-testid={`trash-bin-restore-${it.mint}`}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold border border-white/15 text-muted-foreground hover:text-neon hover:border-neon/40 transition-colors shrink-0"
                >
                  <ArrowCounterClockwiseIcon size={13} weight="bold" /> Restore
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
